import { render, staticRenderFns } from "./DocumentosPleito.vue?vue&type=template&id=643b5109"
import script from "./DocumentosPleito.vue?vue&type=script&lang=js"
export * from "./DocumentosPleito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports